import {
  GET_CITIES, SITE_DETAILS, CREATE_TASK, TASK_LIST, SITE_VISIT_TASK, SITE_VISIT_LIST, SITE_VISIT_BY_ID, RM_CHECK_OUT,SUB_HARDWARE_DROPDOWN
} from "./type";
  
  const initialState = {
    cities: [],
    siteDetails :[],
    createTask:[],
    taskList : [],
    savedVisitTask:[],
    siteVisitList:[],
    siteVisitByIdDetails:[],
    rmCheckOutResponse:[],
    subHardwareDropdownList:[]
  }
  
  const NetEnggReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_CITIES:
        return {
          ...state,
          cities: payload,
        };
      case SITE_DETAILS:
        return {
          ...state,
          siteDetails: payload,
        };
      case CREATE_TASK:
        return {
          ...state,
          createTask: payload,
        };
      case TASK_LIST:
        return {
          ...state,
          taskList: payload,
        };
      case SITE_VISIT_TASK:
        return {
          ...state,
          savedVisitTask: payload,
        };
      case SITE_VISIT_LIST:
        return {
          ...state,
          siteVisitList: payload,
        };
      case SITE_VISIT_BY_ID:
        return {
          ...state,
          siteVisitByIdDetails: payload,
        };
      case SUB_HARDWARE_DROPDOWN:
        return {
          ...state,
          subHardwareDropdownList: payload,
        };
      case RM_CHECK_OUT:
        return {
          ...state,
          rmCheckOutResponse: payload,
        };
      default:
        return {
          ...state,
        };
    }
  };
  
  export default NetEnggReducer;